export const SIGNING_FLOW_STEPS = [
    {
        label: 'Add Bank Account',
        routes: [
            '/autopay',
            '/autopay/connect',
            '/autopay/add-bank-account',
            '/autopay-account-selection',
        ],
    },
    {
        label: 'Authorize Down Payment',
        routes: ['/down-payment'],
        requiresDownPayment: true,
    },
    {
        label: 'Set Up Autopay',
        routes: ['/autopay-auth', '/autopay-auth/one-time-payment'],
    },
    {
        label: 'Review Terms',
        routes: ['/sign-agreement'],
    },
];
export const SIGNING_FLOW_START_ROUTE = '/autopay';
export const SIGNING_FLOW_RESUME_ROUTES = {
    connect_bank_account: SIGNING_FLOW_START_ROUTE,
    setup_initial_payment: SIGNING_FLOW_START_ROUTE,
    sign_agreement: '/sign-agreement',
};
export const CHANGE_BANK_ACCOUNT_PARAM = 'change';
export const PLAID_FALLBACK_PARAM = 'plaidFallback';
export const BANK_ACCOUNT_PARAM = 'bankAccountId';
export const ACTIVE_BANK_ACCOUNT_STATUS = 'active';
